<template>
  <header class="header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-8 col-sm-7 col-md-7 col-lg-8 nowrap">
          <div class="header__logo">
            <router-link to="/dashboard">
              <img
                src="@/assets/img/bettermynd-logo-small.png"
                alt="BetterMynd Logo"
              >
            </router-link>
          </div>
          <nav class="header__nav d-none d-lg-inline-block">
            <navigation-menu />
          </nav>
        </div>
        <div class="col-12 col-md-5 col-lg-4 d-none d-lg-block text-right">
          <header-buttons />
        </div>
        <div class="col-4 col-sm-5 d-lg-none text-right">
          <off-canvas-menu />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu.vue';
import HeaderButtons from '@/components/HeaderButtons.vue';
import OffCanvasMenu from '@/components/OffCanvasMenu.vue';

export default {
  name: 'Header',
  components: {
    NavigationMenu,
    HeaderButtons,
    OffCanvasMenu,
  },
};
</script>

<style lang="scss" scoped>
$header-height: 46px;

.header {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: $header-height;
  padding: 0;
  background: #0f2133;
  border-bottom: none;

  .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }

  &__logo {
    display: inline-block;
    height: $header-height;
    vertical-align: top;
    position: relative;
    width: 62px;
    text-align: center;

    ::v-deep a {
      height: $header-height;
      width: 100%;
      min-width: 62px;
      display: block;
      line-height: $header-height;
    }

    img {
      width: auto;
      height: 32px;
      position: relative;
      top: -2px;
    }
  }

  ::v-deep &__nav {
    display: inline-block;
    vertical-align: top;

    ul {
      list-style-type: none;
      padding-left: 0;
      margin-bottom: 0;

      li {
        display: inline-block;
        margin-right: 1.2rem;
        margin-left: 1.2rem;
        line-height: $header-height;
        font-size: 15px;

        @media (max-width: 1080px) {
          margin-left: 1rem;
          margin-right: 1rem;
        }

        a {
          color: #8ca0ab;
          opacity: 1;
          text-decoration: none;
          display: inline-block;
          height: $header-height;
          letter-spacing: 0.025rem;

          &:hover {
            color: #fff;
            opacity: 1;
            border-bottom: solid 3px #254464;
          }

          &.router-link-active {
            cursor: pointer;
            border-bottom: solid 3px  #237cf2;
            font-weight: 500;
            color: #fff;
            opacity: 1;
          }
        }

        button {
          color: #8ca0ab;
          opacity: 1;
          text-decoration: none;
          display: inline-block;
          height: $header-height;
          letter-spacing: 0.025rem;
          background:none;
          border:none;

          &:hover {
            color: #fff;
            opacity: 1;
            border-bottom: solid 3px #254464;
          }

          &.router-link-active {
            cursor: pointer;
            border-bottom: solid 3px  #237cf2;
            font-weight: 500;
            color: #fff;
            opacity: 1;
          }
        }
      }
    }
  }
}

.nowrap {
  white-space: nowrap;
}
</style>
